var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "data-list" } },
    [
      _c("j-headful", { attrs: { title: _vm.$route.meta.title } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "studio-page-header",
          class: { "studio-page-header-long": !_vm.is_sidebar_minimized }
        },
        [
          _c("h4", { staticClass: "title-tab-experience-manager" }, [
            _vm._v("VISUAL PROGRAMMING")
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "custom-search",
              attrs: { slot: "beforeFilter" },
              slot: "beforeFilter"
            },
            [
              _c(
                "b-form",
                { attrs: { inline: "" } },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn-add-gradient mr-2",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.showCreateList = true
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-plus" }),
                      _vm._v(" Create\n        ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    {
                      staticClass: "form-header-list",
                      attrs: { inline: "" },
                      on: {
                        keypress: function($event) {
                          if (!("button" in $event) && $event.keyCode !== 13) {
                            return null
                          }
                          $event.preventDefault()
                          _vm.filter(_vm.filter_data)
                        }
                      }
                    },
                    [
                      _c("j-select", {
                        attrs: {
                          options: _vm.options_search,
                          "error-required": false,
                          placeholder: "Filter By"
                        },
                        model: {
                          value: _vm.select_type,
                          callback: function($$v) {
                            _vm.select_type = $$v
                          },
                          expression: "select_type"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "boundary-line" }),
                      _vm._v(" "),
                      _vm.select_type === "trigger.type"
                        ? _c("j-select", {
                            attrs: {
                              options: _vm.options_type,
                              "error-required": false,
                              placeholder: "Select Object"
                            },
                            model: {
                              value: _vm.select_type_auto,
                              callback: function($$v) {
                                _vm.select_type_auto = $$v
                              },
                              expression: "select_type_auto"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.select_type === "trigger.type"
                        ? _c("div", { staticClass: "boundary-line" })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "search-input" },
                        [
                          _c("i", { staticClass: "fa fa-search" }),
                          _vm._v(" "),
                          _c("b-form-input", {
                            ref: "filterInput",
                            attrs: { placeholder: "Search" },
                            model: {
                              value: _vm.filter_data,
                              callback: function($$v) {
                                _vm.filter_data = $$v
                              },
                              expression: "filter_data"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.showCreateList
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.hidePopupCreateList,
                          expression: "hidePopupCreateList"
                        }
                      ],
                      staticClass: "popup-add-automation"
                    },
                    _vm._l(_vm.createList, function(list) {
                      return _c(
                        "div",
                        { key: list.section, staticClass: "list-section" },
                        [
                          _c("p", { staticClass: "section-text" }, [
                            _vm._v(_vm._s(list.section))
                          ]),
                          _vm._v(" "),
                          _vm._l(list.lists, function(item) {
                            return _c(
                              "div",
                              {
                                key: item.key,
                                staticClass: "item-list",
                                class: { inactive: !item.active },
                                on: {
                                  click: function($event) {
                                    _vm.handleCreateNew(item)
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/" + item.icon),
                                    alt: item.name
                                  }
                                }),
                                _vm._v(" "),
                                _c("p", [_vm._v(_vm._s(item.name))])
                              ]
                            )
                          })
                        ],
                        2
                      )
                    })
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "list-content" },
        [
          _c(
            "j-table-list",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.onClickOutside,
                  expression: "onClickOutside"
                }
              ],
              attrs: { columns: _vm.columns, sorting: _vm.params.sort },
              on: { "sort-change": _vm.changeSorting }
            },
            [
              _c(
                "template",
                { attrs: { slot: "table-body" }, slot: "table-body" },
                [
                  !_vm.isLoading && _vm.dataTable && _vm.dataTable.length > 0
                    ? _vm._l(_vm.dataTable, function(item) {
                        return _c(
                          "tr",
                          {
                            key: item.id,
                            class: {
                              active:
                                _vm.dataSelected &&
                                _vm.dataSelected.id === item.id
                            },
                            on: {
                              click: function($event) {
                                _vm.handleSingleClick(item)
                              },
                              dblclick: function($event) {
                                _vm.handleOpenDetail(item)
                              },
                              mouseup: function($event) {
                                if (
                                  !("button" in $event) &&
                                  _vm._k(
                                    $event.keyCode,
                                    "right",
                                    39,
                                    $event.key
                                  )
                                ) {
                                  return null
                                }
                                if ("button" in $event && $event.button !== 2) {
                                  return null
                                }
                                _vm.handleRightClick(item)
                              },
                              contextmenu: function($event) {
                                $event.preventDefault()
                              }
                            }
                          },
                          [
                            _c(
                              "td",
                              [
                                _c("div", { staticClass: "icon-id-name" }, [
                                  item.trigger.type === "form"
                                    ? _c("img", {
                                        attrs: {
                                          src: require("@/assets/automation/data_manager.svg")
                                        }
                                      })
                                    : item.trigger.type === "event"
                                    ? _c("img", {
                                        attrs: {
                                          src: require("@/assets/automation/event.svg")
                                        }
                                      })
                                    : item.trigger.type === "function"
                                    ? _c("img", {
                                        attrs: {
                                          src: require("@/assets/automation/function.svg")
                                        }
                                      })
                                    : item.trigger.type === "job" ||
                                      item.trigger.type === "dedicated_job"
                                    ? _c("img", {
                                        attrs: {
                                          src: require("@/assets/automation/job.svg")
                                        }
                                      })
                                    : _c("img", {
                                        attrs: {
                                          src: require("@/assets/automation/api.svg")
                                        }
                                      }),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("p", { staticClass: "id" }, [
                                      _vm._v(_vm._s(item.id))
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "name" }, [
                                      _vm._v(_vm._s(item.name || "-"))
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm.isShowPopupRightClick &&
                                _vm.dataSelected &&
                                _vm.dataSelected.id === item.id
                                  ? _c("j-popup-right-click", {
                                      ref: "popupRightClick",
                                      refInFor: true,
                                      attrs: { "use-move": false },
                                      on: {
                                        open: _vm.handleOpenDetail,
                                        "open-new-tab":
                                          _vm.handleOpenNewTabDetail,
                                        download: _vm.handleDownload,
                                        delete: _vm.openModalDelete,
                                        detail: _vm.handleSingleClick,
                                        rename: function($event) {
                                          _vm.toggleModalRename(true)
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.getType(item)) +
                                  "\n              "
                              ),
                              _c("span", {
                                staticStyle: { "font-size": "12px" },
                                domProps: {
                                  innerHTML: _vm._s(_vm.getEvent(item))
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.getSource(item))
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "div",
                                {
                                  staticClass: "status",
                                  class: item.is_active
                                    ? "status-on"
                                    : "status-off"
                                },
                                [
                                  _c("div", { staticClass: "circle-accent" }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(item.is_active ? "ON" : "OFF")
                                    )
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.convertDateTime(item.created_at)) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.convertDateTime(item.updated_at)) +
                                  "\n            "
                              )
                            ])
                          ]
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  (!_vm.isLoading && _vm.dataTable === null) ||
                  (_vm.dataTable && _vm.dataTable.length === 0)
                    ? _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "text-center",
                            attrs: { colspan: _vm.columns.length }
                          },
                          [
                            _vm._v(
                              "\n            No matching records found\n          "
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isLoading || _vm.isLoadingMore
                    ? _vm._l(new Array(10), function(row) {
                        return _c(
                          "tr",
                          { key: row },
                          _vm._l(new Array(_vm.columns.length), function(col) {
                            return _c("td", { key: col }, [
                              _c("div", { staticClass: "skeleton-table" })
                            ])
                          })
                        )
                      })
                    : _vm._e()
                ],
                2
              )
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalDelete",
          staticClass: "mod-form modal-form-ui",
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _vm.isShowModalDelete
            ? _c("j-popup-delete", {
                attrs: { "data-selected": _vm.dataSelected },
                on: { delete: _vm.handleDelete, close: _vm.closeModalDelete }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.isShowModalRename
        ? _c("j-popup-rename", {
            attrs: { "data-selected": _vm.dataSelectedRename },
            on: {
              rename: _vm.handleRename,
              close: function($event) {
                _vm.toggleModalRename(false)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalAddNew",
          staticClass: "modal-add-vp",
          attrs: {
            "hide-header": true,
            "hide-footer": true,
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _vm.typeAddSelected
            ? _c("j-popup-add-new", {
                attrs: {
                  "type-selected": _vm.typeAddSelected,
                  "table-group-options": _vm.tableGroupOptions,
                  "option-event-name": _vm.optionEventName
                },
                on: { "close-modal": _vm.closeModalAddNew }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalAddNewByCode",
          staticClass: "modal-code-vp-wrap",
          attrs: {
            "hide-header": true,
            "hide-footer": true,
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v("CREATE VISUAL PROGRAMMING")
          ]),
          _vm._v(" "),
          _c("label", [_vm._v(" JSON ")]),
          _vm._v(" "),
          _vm.showEditor
            ? _c("j-monaco-editor", {
                ref: "jsonEditor",
                attrs: { value: _vm.jsonData, language: "json" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c("div", { staticClass: "float-to-right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button-border mr-2",
                      on: { click: _vm.closeCodeForm }
                    },
                    [_vm._v("\n            Close\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button-blue",
                      on: { click: _vm.createCodeData }
                    },
                    [_vm._v("\n            Create\n          ")]
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isShowPopupDetail
        ? _c(
            "j-popup-detail",
            { on: { "close-popup": _vm.handleClosePopupDetail } },
            [
              _c("j-popup-detail-vp", {
                attrs: { "data-detail": _vm.dataSelected }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ee78df8e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee78df8e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/visual-programming/jVPList.vue
// module id = null
// module chunks = 